function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".st0{fill:none}.st1{fill:#5c6a7c}");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0 0h24v24H0z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M9.3 16.2l5.4-4.4-5.4-4.4z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M21.3 11.2H21c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.3c.3 0 .6-.2.6-.6-.1-.4-.3-.6-.6-.6zM19 11.2h-.6c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.6c.3 0 .6-.2.6-.6-.1-.4-.3-.6-.6-.6zM6.1 11.2h-.6c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.6c.3 0 .6-.2.6-.6 0-.4-.2-.6-.6-.6zM3.5 11.2H3c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.6c.3 0 .6-.2.6-.6-.1-.4-.3-.6-.7-.6zM16.4 11.2h-.5c.2.2.2.3.2.6s-.1.4-.2.6h.5c.3 0 .6-.2.6-.6 0-.4-.3-.6-.6-.6zM7.5 11.8c0 .3.2.6.6.6v-1.1c-.3-.1-.6.1-.6.5z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "Shape_7_",
  d: "M16.1 11.8c0-.2-.1-.4-.2-.6l-.1-.1-6.1-4.8c-.2-.1-.4-.2-.6-.2-.6 0-1 .4-1 .9v9.7c0 .3.1.5.3.7.2.1.4.2.6.2.2 0 .5-.1.6-.2l6.1-4.9.1-.1c.2-.2.3-.4.3-.6zm-6.8 4.4V7.4l5.5 4.4-5.5 4.4z",
  fill: "#9ea7bc"
});

var SvgIcCenteringVertically = function SvgIcCenteringVertically(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCenteringVertically, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_centering-vertically.ef1a26ad.svg";
export { ForwardRef as ReactComponent };